import Sections from "components/Contractors/sections";
import {ContractorAddressDetails} from "./ContractorAddressDetails";
import {DetailsColumn} from "components/Shared/CrudComponents";
import React from "react";

export const ContractorCompanyAddress = ({contractor, previousContractor, ...columnProps}) => (
    <DetailsColumn section={Sections.CompanyAddress} {...columnProps}>
        <ContractorAddressDetails address={contractor.companyAddress}
                                  previousAddress={previousContractor && { value: previousContractor.companyAddress }}/>
    </DetailsColumn>
)